import { Button, Col, Row, Image, List, Card, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { recordError } from "../../../utils/logService";
import util from "../../../utils/functions/custom";
import service from "../../../services/citizenscienceService";
import { PlusOutlined } from "@ant-design/icons";
import { Messages, Notify } from "../../../services/custom/Messages";
import { openNotification } from "@seims/shared";
import EditProjectPartners from "./EditProjectPartners";
import ContributeModal from "../organizations/ContributeModal";

export default function ProjectPartners({data}) {
  let msg = "";
  let navigate = useNavigate();
  let path = `/citizen-scientist/home`;
  const [projectPartners, setProjectPartners] = useState([]);
  const [projectStatus, setProjectStatus] = useState();
  const [showModal, setShowModal] = useState(false);
  const [projectProfile, setProjectProfile] = useState(
    data.projectProfile
  );
  const [partners, setPartners] = useState([]);
  const [newPartners, setNewPartners] = useState([]);
  const [showContribModal, setShowContribModal] = useState(false);

  const [previewOrgsContrib, setPreviewOrgsContrib] = useState({});
  const [orgsContributions, setOrgsContributions] = useState([]);

  useEffect(() => {
    getPartners();
  }, []);

  const getPartners = async () => {
    try {
      setProjectStatus(data.status);
      var partners = [];
      var contributions = [];
      data?.partners?.forEach((partner) => {
        partner?.contributions.forEach((contribute) => {
          contributions.push({
            label: contribute.value,
            value: contribute.key.toString(),
            key: contribute.key.toString(),
          });
        });
        partners.push({
          id: partner.id,
          name: partner.name,
          address: `${partner.address?.province} (${partner.address?.cityOrTown})`,
          fullAddress: partner.address,
          cityOrTown: partner.address.cityOrTown,
          country: partner.address.country,
          telephone: partner.telephone,
          type: partner.type.value,
          typeid: partner.type.key,
          contributions: contributions,
          email: partner.email,
          otherContribution: partner.otherContribution,
        });
        contributions = [];
      });

      setPartners(partners);
      setProjectPartners(partners);
    } catch (error) {
      recordError(error);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleModalSubmit = async (values) => {
    try {
      let orgContributions = [];
      values.forEach((value) => {
        var contributions = value?.contributions?.map((contribution) =>
          parseInt(contribution.key)
        );
        var org = {};
        if (value.otherContribution === null) {
          org = {
            id: value.id,
            contributions: contributions,
          };
        } else {
          org = {
            id: value.id,
            contributions: contributions,
            otherContribution: value.otherContribution,
          };
        }
        orgContributions.push(org);
      });
      projectProfile.organisationContributions = orgContributions;
      let projectId = data.id;

      const request = await service.editProject(projectProfile, projectId);


      if (request?.status == 200 || request?.status == 201) {
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Project partners");
        openNotification("Project Partners", msg, Notify.SUCCESS);
      }
      setShowModal(false);
    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE);
      openNotification("Partner", msg, Notify.ERROR);
      recordError(error);
    }
  };

  const handleSelectedContributions = (selectedContributions) => {
    // setOrgsContributions([...orgsContributions, selectedContributions]);
    onSelectedOrganization(selectedContributions);
    partnerSubmit();
  };

  const partnerSubmit = () => {
    var sPartners = [];
    var updatedPartners = [];
    var contrib = [];

    partners.forEach((selected) => {
      var part = partners.find((partner) => partner.id === selected.id);
      if (part === undefined) {
        contrib = selected.contributions.map((contr) => {
          return {
            key: parseInt(contr.key),
            value: contr.label,
          };
        });
        var d = {
          id: selected.id,
          address: `${selected.address?.province} (${selected.address?.cityOrTown})`,
          contributions: contrib,
          email: selected.email,
          name: selected.name,
          telephone: selected.telephone,
          type: {
            key: selected.typeid,
            value: selected.type,
          },
          otherContribution:
            selected.otherContribution === undefined
              ? null
              : selected.otherContribution,
        };

        var d = {
          id: selected.id,
          address: `${selected.address?.province} (${selected.address?.cityOrTown})`,
          contributions: contrib,
          email: selected.email,
          name: selected.name,
          telephone: selected.telephone,
          type: {
            key: selected.typeid,
            value: selected.type,
          },
          otherContribution:
            selected.otherContribution === undefined
              ? null
              : selected.otherContribution,
        };

        sPartners.push(d);
        updatedPartners.push(d);
      }
    });

    partners.forEach((selected) => {
      var part = sPartners.find((partner) => partner.id === selected.id);
      if (part === undefined) {
        contrib = selected?.contributions?.map((contr) => {
          return {
            key: parseInt(contr.key),
            value: contr.label,
          };
        });
        var d = {
          id: selected.id,
          address: selected.address,
          contributions: contrib,
          email: selected.email,
          name: selected.name,
          telephone: selected.telephone,
          type: {
            key: selected.typeid,
            value: selected.type,
          },
          otherContribution: selected.otherContribution,
        };
        updatedPartners.push(d);
      }
    });

    handleModalSubmit(updatedPartners);
  };

  const onSelectedOrganization = (selectedOrg) => {
    setPartners((prevSelection) => {
      // if organization does not have contributions then remove it altogether
      if (!prevSelection?.contributions && selectedOrg.length === 0) {
        return [];
      }

      // cater for invalid obejcts which are not array as expected
      if (!Array.isArray(prevSelection)) {
        return [selectedOrg];
      }

      // if user unselects or if orgs are empty then just retrun an empty object
      if (selectedOrg?.length === 0) {
        return [];
      }

      let orgIndex = 0;
      let Ids = [];

      if (Array.isArray(selectedOrg)) {
        // flatten tha array in order to ease saving to backend
        Ids = selectedOrg?.map((x) => x.id);
        orgIndex = prevSelection.findIndex((org) => Ids.includes(org.id));
      } else {
        orgIndex = prevSelection.findIndex((org) => org.id === selectedOrg.id);
      }

      if (orgIndex === -1) {
        return [...prevSelection, selectedOrg];
      } else {
        // Update the existing organization contributions

        const updatedSelection = prevSelection.map((org, index) => {
          // Cases where the organization has not changed, only update floating info like otherContributions
          if (index === orgIndex) {
            org.otherContribution = selectedOrg.otherContribution;
            org.contributions = selectedOrg.contributions;
            return {
              ...org,
              contributions: selectedOrg.contributions,
            };
          }
          return org;
        });

        if (Ids.length > 0) {
          if (updatedSelection.length != selectedOrg.length) {
            return updatedSelection.filter((record) => Ids.includes(record.id));
          }
        }

        return updatedSelection;
      }
    });
  };

  const onShowContributeModal = (value) => {
    setShowContribModal(value);
  };

  const handlePartnerUpdate =(newPartners)=> {
    console.log("NEW ADDED PARTNER", newPartners)
    setNewPartners(newPartners);
  }

  const onUpdateContributions = (selected) => {
    let previewContribution = {};
    if (selected) {
      if (partners.length === 0) {
        previewContribution = orgsContributions.find(
          (c) => c.id === selected.id
        );
      } else {
        previewContribution = partners.find((c) => c.id === selected.id);
      }

      if (previewContribution) {
        setPreviewOrgsContrib(previewContribution);
      } else {
        setPreviewOrgsContrib(selected);
      }
      onShowContributeModal(true);
    }
  };

  const onAddPartner = () => {
    setShowModal(true);
  };

  const editParticipant = (id) => {
    const key = id;
    navigate(`/view-project/${key}`);
  };

  console.log("PARTNERS", partners)

  return (
    <div className="">
      <Row>
        <Col xs={24}>
          <div className="public-portal-section">
            <h2> Citizen Science - {data.name}</h2>
          </div>
        </Col>
      </Row>
      {/* {(data.status !== "Rejected" && data.status !== "Closed") && ( */}
      <Col xs={24}>
        <h3 className="center-align">
          Project Status -{" "}
          <span style={{ color: data.statusColor }}>
            {data.status}
          </span>{" "}
        </h3>
      </Col>
      {/* )} */}
      <Card
        bordered={false}
        headStyle={{ border: 0, textAlign: "center" }}
        key="project-details-card"
      >
        <Row>
          <Col xs={12}>
            {" "}
            <h3 className="h3-text">Project Partners</h3>
          </Col>
          {data.status !== "Rejected" && data.status !== "Closed" && (
            <Col xs={12}>
              <Button
                key="add-new-p"
                className="right-align-button add-button"
                type="primary" shape="round"
                onClick={onAddPartner}
                icon={<PlusOutlined />}
              >
                Add Partner
              </Button>
            </Col>
          )}
        </Row>
        <List
          style={{ paddingLeft: "20px" }}
          itemLayout="vertical"
          pagination={{
            pageSize: 5,
          }}
          // dataSource={projectPartners}
          dataSource={newPartners}
          renderItem={(partner) => (
            <List.Item key={partner.id}>
              <Card className="card-border">
                <Row >
                  <Col className="partner-icon" xs={3} md={2}>
                    <Image
                      src={require("../../../assets/Customized-Partnerships.png")}
                      preview={false}
                    />
                  </Col>
                  {/* <Col xs={2} md={2}></Col> */}
                  <Col lg={{offset:1, span: 20}} xs={24} md={24}>
                    <Row style={{paddingBottom:10}}>
                      <Col xs={16} md={16}>
                        <b> {partner.name}</b>
                      </Col>
                      <Col xs={8} md={8}>
                        <Image
                          src={require("../../../assets/hand-coin.png")}
                          preview={false}
                        />
                        {partner.contributions !== undefined &&
                          partner.contributions
                            .map((item) => `${item.label}`)
                            .join(", ")}
                      </Col>
                    </Row>
                    <Row style={{paddingBottom:10}}>
                      <Col xs={8} md={8}>
                        <Image
                          src={require("../../../assets/phone.png")}
                          preview={false}
                        />
                        {partner.telephone}
                      </Col>
                      <Col xs={8} md={8}>
                        <Image
                          src={require("../../../assets/mail.png")}
                          preview={false}
                        />
                        {partner.email}
                      </Col>
                      <Col xs={8} md={8}>
                        <Image
                          src={require("../../../assets/Mask-Group-3.png")}
                          preview={false}
                        />
                        {partner.type}
                      </Col>
                    </Row>
                    <Row style={{paddingBottom:10}}>
                      <Col xs={8} md={8}>
                        <Image
                          src={require("../../../assets/baseline-place-24px.png")}
                          preview={false}
                        />
                        {partner.cityOrTown}
                        {", "}
                        {partner.country}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {data.status !== "Rejected" &&
                  data.status !== "Closed" && (
                    <Row justify="end">
                      <Col
                        xs={12}
                        sm={6}
                        md={5}
                        lg={3}
                        style={{ paddingRight: 10 }}
                      >
                        <Tooltip
                          placement="top"
                          title={"View or update contributions"}
                        >
                          <Button
                            type="primary"
                            shape="round"
                            block
                            onClick={() => onUpdateContributions(partner)}
                          >
                            View
                          </Button>
                        </Tooltip>
                      </Col>
                      {/* <Col xs={12} sm={6} md={5} lg={3}>
                        <Tooltip
                          placement="top"
                          title={
                            "Remove or disassociate partner from the project"
                          }
                        >
                          <Button
                            type="danger"
                            shape="round"
                            block
                            onClick={() => editParticipant(partner.id)}
                          >
                            Remove
                          </Button>
                        </Tooltip>
                      </Col> */}
                    </Row>
                  )}
              </Card>
            </List.Item>
          )}
        />
      </Card>

      <ContributeModal
        key={"project-partner-modal"}
        onShow={onShowContributeModal}
        show={showContribModal}
        previewOrgsContrib={previewOrgsContrib}
        setOrgsContributions={handleSelectedContributions}
      />

      <Row>
        <Col xs={24}>
          <EditProjectPartners
            key="edit-project-details"
            partnerData={projectPartners}
            selectedPartners={partners}
            visible={showModal}
            onCancel={handleCancel}
            onModalSubmit={handleModalSubmit}
            newPartners={newPartners}
            setNewPartners={handlePartnerUpdate}
          />
        </Col>
      </Row>
    </div>
  );
}
